/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Colors from 'constants/Colors';
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import { Row, Col } from 'components/Grid';
import { SelectField, Label, CheckBox, GridColumnTitle } from "components/Form";
import DialogComponent from "components/Dialog";
import Loader from 'components/Loader';
import {
  ButtonContent,
  Text,
  DialogCancel,
  DialogConfirm,
  DialogSelect,
  Line,
  Scrollbox,
  Title,

  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  LabelEdit,
  InlineLabel
} from './styles';
import { Icon, LostCancelButton } from 'components/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import ModalContacts from 'components/ModalContacts/index';
import Tab from 'components/Tab/index';
import { useHeaderNbi, useGetPolicyStampStatus } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService'

// Status codes para aprovação do diretor
const DIRECTOR_APPROVAL_STATUSES = [244, 245];

export default function StampStatusList(props) {
  const authContext = useContext(GlobalAuthContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const [summary, setSummary] = useState({});
  const [isSigned, setSigned] = useState(false);
  const [isPartialSigned, setIsPartialSigned] = useState(false);

  const [endosementOffRiskAvailable, setEndosementOffRiskAvailable] = useState(false);
  const [endorsementCancellationAvailable, setEndorsementCancellationAvailable] = useState(false);
  const [endorsementNotPreAgreedAvailable, setEndorsementNotPreAgreedAvailable] = useState(false);
  const [endosementChangesAvailable, setEndosementChangesAvailable] = useState(false);
  const [endorsementOffRiskCanceled, setEndosementOffRiskCanceled] = useState(false);
  const [endorsementCancellationCanceled, setEndorsementCancellationCanceled] = useState(false);
  const [endorsementNotPreAgreedCanceled, setEndorsementNotPreAgreedCanceled] = useState(false);
  const [endorsementChangesCanceled, setEndorsementChangesCanceled] = useState(false);
  const [endorsementOffRiskBound, setEndorsementOffRiskBound] = useState(false);
  const [endorsementCancellationBound, setEndorsementCancellationBound] = useState(false);
  const [endorsementNotPreAgreedBound, setEndorsementNotPreAgreedBound] = useState(false);
  const [endorsementChangesBound, setEndorsementChangesBound] = useState(false);
  const [endorsementPolicyExtensionAvailable, setEndorsementPolicyExtensionAvailable] = useState(false);
  const [endosementPolicyExtensionCanceled, setEndorsementPolicyExtensionCanceled] = useState(false);
  const [endorsementPolicyExtensionBound, setEndorsementPolicyExtensionBound] = useState(false);
  const [isBound, setIsBound] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [issueOperationId, setIssueOperationId] = useState(false);
  const [operationMigratedEmpty, setOperationMigratedEmpty] = useState(false);
  const [isMcAvailable, setIsMcAvailable] = useState(false);
  const [paymentPackCreated, setPaymentPackCreated] = useState(false);
  const [sendDirectorApproval, setSendDirectorApproval] = useState(false);
  const [endorsementType, setEndorsementType] = useState("");
  const [filter, setFilter] = useState(
    {
      key: null,
      direction: null,
    }
  );
  const [data, setData] = useState([]);
  const [modalUnderwriter, setModalUnderwriter] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [insurerContacts, setInsurerContacts] = useState(false);
  const [selectedSigner, setSelectedSigner] = useState([]);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useGetPolicyStampStatusData,
    loading: useGetPolicyStampStatusLoading,
    error: useGetPolicyStampStatusError,
    status: useGetPolicyStampStatusStatus,
    request: useGetPolicyStampStatusRequest,
  } = useGetPolicyStampStatus(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useGetPolicyStampStatusLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useGetPolicyStampStatusLoading]);

  const columns = [
    {
      title: "Party",
      value: "nmParty"
    },
    {
      title: "Signer",
      value: "signer",
    },
    {
      title: "Situation",
      value: "situation"
    },
    {
      title: "signature Requested",
      value: "signatureRequested"
    },
    {
      title: "signature Date",
      value: "signatureDate"
    },
    {
      title: "Actions",
      value: ""
    },
  ];

  const [lostDeal, setLostDeal] = useState({
    formated: [],
    array: [],
  });

  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
  });

  const HandleLostSubmit = (selectedID) => {
    if (!selectedID) {
      mc.error("Please, select at least one option.");
      return;
    }

    cancelStamps();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.updateQuoteEdit(props.match.params.idOperation, selectedID).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      history.push('/list');
    })
  }

  function handleBound() {
    mc.success('Cancellation Complete - No credits or debits are outstanding')
    history.push('/policies');
  }

  function handleSortList(key) {
    let direction = 'asc';
    if (filter.key === key && filter.direction === 'asc') {
      direction = 'desc';
    }
    setFilter({ key: key, direction: direction });
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setEndorsementType(data.ret_value.endorsmentType);
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          currency: data.ret_value.currency,
          nmObligor: data.ret_value.nmObligor,
          isFramework: data.ret_value.isFramework,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function listContacts(signers) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.listStampsContacts(props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          loading.stop();
          return;
        }

        const requiresReprocessing = signers.some(signer =>
          !data.ret_value.contacts.find(contact => contact.idPersonInsurer === signer.idPerson)
        );

        if (requiresReprocessing) {
          mc.warning("One or more parties were modified. This deal must be manually re-processed to ensure consistency.");
        }
        
        setContacts(data.ret_value.contacts);
        loading.stop();
      }).catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  };

  function getGridItems() {
    useGetPolicyStampStatusRequest().then(({data: res}) => {
        if (res.ret_code != 200) {
          mc.error(res.ret_msg_details);
          return;
        }

        if (!res.ret_value.signers[0]) {
          setOperationMigratedEmpty(true);
        }

        let data = res.ret_value.signers.map(item => {
          const signer = {
            nmParty: item.party,
            situation: item.status,
            signatureDate: item.signedAt,
            signatureRequested: item.sentAt,
            signer: item.realEmailData,
            idPerson: item.idPerson,
            idContact: item.idContact,
            recipientId: item.recipientId
          }

          if (item.status === 'SIGNED' && !isPartialSigned)
            setIsPartialSigned(true);
          
          return signer;
        }).sort((a,b) => String(a?.nmParty).localeCompare(String(b?.nmParty)));

        setData(data);
        setIsMcAvailable(res.ret_value.marketingCompositionAvailable);
        setSigned(res.ret_value.policyExecutionAvailable);

        setEndosementOffRiskAvailable(res.ret_value.endorsementOffRiskAvailable);
        setEndosementOffRiskCanceled(res.ret_value.endorsementOffRiskCanceled);
        setEndorsementOffRiskBound(res.ret_value.endorsementOffRiskBound);

        setEndorsementPolicyExtensionAvailable(res.ret_value.endorsementPolicyExtensionAvailable);
        setEndorsementPolicyExtensionCanceled(res.ret_value.endorsementPolicyExtensionCanceled);
        setEndorsementPolicyExtensionBound(res.ret_value.endorsementPolicyExtensionBound);

        setEndorsementCancellationAvailable(res.ret_value.endorsementCancellationAvailable);
        setEndorsementCancellationCanceled(res.ret_value.endorsementCancellationCanceled);
        setEndorsementCancellationBound(res.ret_value.endorsementCancellationBound);

        setEndorsementNotPreAgreedAvailable(res.ret_value.endorsementNotPreAgreedAvailable);
        setEndorsementNotPreAgreedCanceled(res.ret_value.endorsementNotPreAgreedCanceled);
        setEndorsementNotPreAgreedBound(res.ret_value.endorsementNotPreAgreedBound);

        setEndosementChangesAvailable(res.ret_value.endorsementChangesAvailable);
        setEndorsementChangesCanceled(res.ret_value.endorsementChangesCanceled);
        setEndorsementChangesBound(res.ret_value.endorsementChangesBound);

        setIsFinished(res.ret_value.isBound);
        setPaymentPackCreated(res.ret_value.hasPaymentPack);
        setSendDirectorApproval(res.ret_value.sendDirectorApproval);

        setIssueOperationId(res.ret_value.issueOperation);
        listContacts(res.ret_value.signers);
      })
      .catch(() => {})
  }

  function handleDownloadPartialSignaturesDocument() {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetPartialSignaturesDocument(props.match.params.idOperation).then(data => {
      if (data.status !== 200) {
        mc.error(data.ret_msg_details);
        loading.stop();
        throw new Error();
      }

      if (data.status === 200) 
        return data.blob();
    }).then(data => {
      const url = window.URL.createObjectURL(data);
      const a = document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = 'partial-policy-stamp.zip';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      loading.stop();
    }).catch(err => {
      loading.stop();
    });
  }

  function cancelStamps() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestDeletePolicyStampStatus(props.match.params.idOperation)
      .then(x => x.json()).then(res => {
        if (res.ret_code !== 200) {
          loading.stop();
          mc.error(res.ret_msg_details);
          return;
        }
        loading.stop();
        history.goBack();
      })
      .catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${cancelStamps.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function signatureRequest() {
    history.push(`/broking/stamp-request-contacts/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct || null });
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    
    getGridItems();
    handleSummary();
    handleOperationInfo();
  }, []);

  async function handleOperationInfo() {
    useOperationInfoRequest(props.match.params.idOperation).then(({data: response}) => {
        setIsBound(response?.isBound);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }

  function clonePolicyPack() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestClonePolicyPack(props.match.params.idOperation)
      .then(x => x.json()).then(res => {
        if (res.ret_code !== 200) {
          loading.stop();
          mc.error(res.ret_msg_details);
          return;
        }

        const idDomainStatus = res.ret_value.idDomainStatus;

        loading.stop();

        if (idDomainStatus) {
          if (DIRECTOR_APPROVAL_STATUSES.includes(idDomainStatus)) {
            history.push(`/broking/policy-pack-director-approval/${props.match.params.idOperation}`)
          } else {
            history.push(`/broking/payment-pack-send-client-insurer/${props.match.params.idOperation}`)
          }
        } else {
          history.push(`/broking/payment-pack-send-client-insurer/${props.match.params.idOperation}`)
        }

      })
      .catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${clonePolicyPack.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleUnderwriterChange(item) {
    const insurerFiltered = [...contacts.filter(insurer => insurer.idPersonInsurer === item.idPerson)];
    const signerFiltered = insurerFiltered[0]?.contacts?.filter(contact => contact.idContact === item.idContact);
    let insurerContacts = [...insurerFiltered[0]?.contacts || []];

    let sameInsurerCompany = data
      .filter(insurer => insurer.idPerson === item.idPerson)
      .find(contact => contact.idContact !== item.idContact);

    if (sameInsurerCompany) {
      insurerContacts = insurerContacts.filter(contact => contact.idContact !== sameInsurerCompany.idContact);
    }

    const insurer = {
      ...item,
      contacts: insurerContacts
    }

    if (signerFiltered && signerFiltered.length) {
      const initialSigner = {
        name: signerFiltered[0].nameContact,
        email: signerFiltered[0].email,
        idContact: signerFiltered[0].idContact,
        recipientId: item.recipientId,
        idPerson: item.idPerson
      }

      setSelectedSigner([initialSigner]);
    }

    setInsurerContacts(insurer);
    setModalUnderwriter(true);
  }

  function handleSelect(contact) {
    const select = {
      name: contact.nameContact,
      email: contact.email,
      idContact: contact.idContact,
      recipientId: insurerContacts.recipientId,
      idPerson: insurerContacts.idPerson
    };

    const alreadySelected = selectedSigner.find((item) => item.idContact === select.idContact);

    if (!alreadySelected)
      setSelectedSigner([select]);
  };

  const renderFlowClient = () => {
    if (isClient) return (
      <HasPermission permission={!isBound}>
        <div style={{ marginTop: "5px" }}>
          <LostCancelButton idOperation={props.match?.params?.idOperation} />
        </div>
      </HasPermission>
    )

    return (
      <HasPermission permission={!isBound}>
        {!isSigned &&
          <>
            <HasPermission permission={isPartialSigned}>
              <Button
                secundary
                onClick={() => handleDownloadPartialSignaturesDocument()}
                style={{ marginRight: "10px", marginTop: "5px" }}
              >
                DOWNLOAD CURRENT VERSION
              </Button>
            </HasPermission>
            <div style={{ marginTop: "5px" }}>
              <LostCancelButton idOperation={props.match?.params?.idOperation} />
            </div>
            <HasPermission permission={props.permissions.EXECUTION_SEND}>
              <Button
                secundary
                onClick={() => cancelStamps()}
                style={{ marginLeft: "10px", marginTop: "5px" }}
                disabled={isMcAvailable}
              >
                CANCEL STAMPS REQUEST
              </Button>
            </HasPermission>
            <HasPermission permission={props.permissions.MARKETING_COMPOSITION && isMcAvailable}>
              <Button
                onClick={() => history.push(`/broking/market-composition/${props.match.params.idOperation}`)}
                style={{ marginLeft: "10px", marginTop: "5px" }}
                third
              >
                CDR
              </Button>
            </HasPermission>
          </>
        }
      </HasPermission>
    )
  }

  const renderEndorsement = () => {
    return (
      <HasPermission permission={!isBound}>
        {((!endorsementOffRiskBound && !endorsementOffRiskCanceled) || (!endorsementPolicyExtensionBound && !endosementPolicyExtensionCanceled)) && ((!endorsementCancellationBound && !endorsementCancellationCanceled) || (!endorsementNotPreAgreedBound && !endorsementNotPreAgreedCanceled)
          || (!endorsementChangesBound && !endorsementChangesCanceled)) ? <>
          <HasPermission permission={isPartialSigned && !isClient && !isSigned}>
            <Button
              secundary
              onClick={() => handleDownloadPartialSignaturesDocument()}
              style={{ marginRight: "10px", marginTop: "5px" }}
            >
              DOWNLOAD CURRENT VERSION
            </Button>
          </HasPermission>
          <div style={{ marginTop: "5px" }}>
            <LostCancelButton idOperation={props.match?.params?.idOperation} />
          </div>
          <HasPermission permission={props.permissions.EXECUTION}>
            <Button
              secundary
              onClick={() => cancelStamps()}
              style={{ marginLeft: "10px", marginTop: "5px" }}>
              CANCEL STAMPS REQUEST
            </Button>
          </HasPermission>
        </> : (endorsementOffRiskCanceled || endosementPolicyExtensionCanceled || endorsementCancellationCanceled || endorsementNotPreAgreedCanceled || endorsementChangesCanceled) && <>
          <HasPermission permission={props.permissions.EXECUTION}>
            <Button
              style={{ marginLeft: "10px", marginTop: "5px" }}
              primary
              id="btnSignatureRequest"
              onClick={(e) => { signatureRequest() }}>
              SIGNATURE REQUEST
            </Button>
          </HasPermission>
        </>
        }
      </HasPermission>
    );
  }

  const getTitle = () => {
    let title = "STAMPS - ELECTRONIC SIGNATURE";
    if (endosementOffRiskAvailable) {
      title = "ENDORSEMENT - OFF RISK - ELECTRONIC SIGNATURE";
    } else if (endorsementCancellationAvailable) {
      title = "ENDORSEMENT - CANCELLATION - ELECTRONIC SIGNATURE";
    }

    return title;
  };

  async function resendStamps(stamp) {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.reSendPolicyStampInsurer(props.match.params.idOperation, stamp)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        loading.stop();
        window.location.reload();
      })
      .catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"} >
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard title={getTitle()} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <DialogComponent
          icon={dialog.icon}
          title={dialog.title}
          
          show={dialog.visible}
          setDialog={setDialog}>

          <Formik initialValues={{ reasons: '' }} onSubmit={(e) => { HandleLostSubmit(e.reasons); }}>
            <Form>
              <DialogSelect>
                <Field
                  name="reasons"
                  placeholder="Select the reason the deal was lost"
                  component={SelectField}
                  options={lostDeal.formated}
                />

              </DialogSelect>
              <DialogCancel onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDialog({ visible: false, title: null, icon: null, args: null }); }}>Cancel</DialogCancel>
              <DialogConfirm type="submit">Confirm</DialogConfirm>
            </Form>
          </Formik>
        </DialogComponent>

        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column, index) =>
                <TableHeader>

                  <GridColumnTitle style={{ textTransform: 'uppercase' }} onClick={() => handleSortList(column.value)}>
                    {column.title}
                  </GridColumnTitle>

                  {filter.key === column.value && filter.direction === "asc" ?
                    <Icon name={"arrowup"} /> :
                    filter.key === column.value && filter.direction === "desc" ?
                      <Icon name={"arrowdown"} /> :
                      ''}
                </TableHeader>)
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCollum>
                  <LabelEdit>{item.nmParty}</LabelEdit>
                </TableCollum>
                <TableCollum>
                  <LabelEdit>{item.signer}</LabelEdit>
                </TableCollum>
                <TableCollum>
                  <LabelEdit>{item.situation}</LabelEdit>
                </TableCollum>
                <TableCollum>
                  <LabelEdit>{item.signatureRequested}</LabelEdit>
                </TableCollum>
                <TableCollum>
                  <LabelEdit>{item.signatureDate}</LabelEdit>
                </TableCollum>
                <TableCollum>
                  {
                    item.signer ?
                      <Icon
                        name="emailStamps"
                        onClick={() => item.situation === "SENT" ? handleUnderwriterChange(item) : {}}
                        style={item.situation === "SENT"
                          ? { cursor: "pointer", marginLeft: '0px' }
                          : { cursor: "not-allowed" }
                        }
                      />
                      :
                      <></>
                  }
                </TableCollum>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {insurerContacts &&
          <ModalContacts
            show={modalUnderwriter}
            onModalClose={() => setModalUnderwriter(false)}
            onConfirm={() => resendStamps(selectedSigner[0])}
          >
            <Row style={{ marginBottom: "10px" }}>
              <Title>UNDERWRITER</Title>
            </Row>
            <Row>
              <Col md={12} sm={12}>
                <Title>TO</Title>
                <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                  <Title>
                    {insurerContacts.nmParty}
                  </Title>
                </Row>
                <Scrollbox>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableHeader>
                        </TableHeader>
                        <TableHeader>
                          <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                            Legal Entity
                          </GridColumnTitle>
                        </TableHeader>
                        <TableHeader>
                          <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                            Name
                          </GridColumnTitle>
                        </TableHeader>
                        <TableHeader>
                          <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                            Department
                          </GridColumnTitle>
                        </TableHeader>
                        <TableHeader>
                          <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                            E-mail
                          </GridColumnTitle>
                        </TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {insurerContacts.contacts.length ? insurerContacts.contacts.map((contact) => (
                        <TableRow>
                          <TableCollum>
                            <label>
                              <CheckBox
                                onChange={() => handleSelect(contact)}
                                checked={selectedSigner.find((item) => item.idContact === contact.idContact) ? true : false}
                              />
                            </label>
                          </TableCollum>
                          <TableCollum>
                            <InlineLabel>Legal Entity</InlineLabel>
                            <LabelEdit>
                              {contact.legalEntity}
                            </LabelEdit>
                          </TableCollum>
                          <TableCollum >
                            <InlineLabel>Name</InlineLabel>
                            <LabelEdit>{contact.nameContact}</LabelEdit>
                          </TableCollum>
                          <TableCollum>
                            <InlineLabel>Department</InlineLabel>
                            <LabelEdit>{contact.personContactDepartment}</LabelEdit>
                          </TableCollum>
                          <TableCollum >
                            <InlineLabel>E-mail</InlineLabel>
                            <LabelEdit>{contact.email}</LabelEdit>
                          </TableCollum>
                        </TableRow>
                      )) : (
                        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                          <Label>
                            No results found.
                          </Label>
                        </Row>
                      )
                      }
                    </TableBody>
                  </Table>
                </Scrollbox>
              </Col>
            </Row>
          </ModalContacts>
        }

        <ButtonContainer>
          <Button forth onClick={() => { history.goBack() }}>&lt; Back</Button>
          <RenderButtons idOperation={props.match?.params?.idOperation}>
            <HasPermission permission={true}>
              {(operationMigratedEmpty && !summary.isFramework) ? '' :
                <ButtonContent>
                  {endosementOffRiskAvailable || endorsementPolicyExtensionAvailable || endorsementCancellationAvailable || endorsementNotPreAgreedAvailable || endosementChangesAvailable ? renderEndorsement() : renderFlowClient()}
                  <HasPermission 
                    permission={
                      isSigned &&
                      !isClient && 
                      !endosementOffRiskAvailable && 
                      !endorsementPolicyExtensionAvailable && 
                      !paymentPackCreated && 
                      !isFinished && 
                      props.permissions.PAYMENT_PACK_CREATE
                    }
                  >
                    <Button
                      primary
                      style={{ marginLeft: "10px", marginTop: "5px" }}
                      onClick={() => history.push(`/broking/payment-pack-configuration/${issueOperationId}`)}
                    >
                      PROCESS INVOICES
                    </Button>
                  </HasPermission>

                  <HasPermission permission={!isClient && !endosementOffRiskAvailable && !endorsementPolicyExtensionAvailable && !paymentPackCreated && isFinished}>
                    <Button
                      primary
                      style={{ marginLeft: "10px", marginTop: "5px" }}
                      onClick={() => handleBound()}
                      disabled={!isSigned}>
                      FINISH ENDORSEMENT
                    </Button>
                  </HasPermission>
                  
                  {(endorsementType && endorsementType !== 'client-change') && (
                    <HasPermission permission={sendDirectorApproval && props.permissions.ENDORSEMENT_PACK_SEND_DIRECTOR_APPROVAL}>
                      <Button
                        primary
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        onClick={() => clonePolicyPack()}
                        disabled={!isSigned}
                      >
                        Send Director Approval
                      </Button>
                    </HasPermission>)}
                </ButtonContent>
              }
            </HasPermission>
          </RenderButtons>
        </ButtonContainer>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ContentCard >
    </Layout >
  )
}
